import React from "react";
import { Button } from "reactstrap";

export const BuildingEditStepper = ({
    steps = [],
    activeIndex = 0,
    showSiteWorks = false,
    onStepClick,
}) => (
    <div className="building-edit-stepper">
        {steps
            .filter((step) => step.key !== "site-works" || showSiteWorks)
            .map((step) => {
                const index = steps.findIndex((item) => item.key === step.key);
                return (
                    <div
                        key={step.key}
                        className={`building-edit-step ${activeIndex === index ? "active" : ""}`}
                        style={{ cursor: onStepClick ? "pointer" : "default" }}
                        onClick={() => onStepClick && onStepClick(index)}
                    >
                        {step.label}
                    </div>
                );
            })}
    </div>
);

export const BuildingSummaryCard = ({ title, value }) => (
    <div className="building-summary-card">
        <div className="title">{title}</div>
        <div className="value">{value}</div>
    </div>
);

export const BuildingListCard = ({
    serial,
    name,
    isPrimary = false,
    conditionLabel = "Condition not set",
    hasCondition = false,
    isSaved = false,
    onViewDetails,
    onDelete,
    deleting = false,
}) => (
    <div className="building-list-card">
        <div className="building-list-card-main">
            <div className="building-list-card-title">
                {serial}. {name}
            </div>
            <div className="building-list-card-meta">
                <span className={`building-list-badge ${isPrimary ? "primary" : ""}`}>
                    {isPrimary ? "Primary" : "Not primary"}
                </span>
                <span className={`building-list-badge ${hasCondition ? "" : "warning"}`}>
                    Condition: {conditionLabel}
                </span>
                <span className={`building-list-badge ${isSaved ? "" : "warning"}`}>
                    {isSaved ? "Saved" : "Pending"}
                </span>
            </div>
        </div>
        <div className="d-flex gap-2">
            {onDelete ? (
                <Button
                    color="danger"
                    size="sm"
                    onClick={onDelete}
                    disabled={deleting}
                    title={isSaved ? "Remove building" : "Remove pending building"}
                >
                    <i className={deleting ? "ri-loader-4-line" : "ri-delete-bin-line"} />
                </Button>
            ) : null}
            <Button color={isSaved ? "primary" : "success"} size="sm" onClick={onViewDetails}>
                {isSaved ? "View details" : "Edit & Save"}
            </Button>
        </div>
    </div>
);

export const BuildingDetailHeader = ({
    serial,
    name,
    isPrimary = false,
    conditionLabel = "Condition not set",
    onBack,
    onDelete,
    deleting = false,
}) => (
    <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
        <div>
            <div className="building-slot-title">
                {serial}. {name}
            </div>
            <div className="text-muted small">
                {isPrimary ? "Primary building" : "Not primary"} · Condition: {conditionLabel}
            </div>
        </div>
        <div className="d-flex gap-2">
            {onDelete ? (
                <Button
                    color="danger"
                    size="sm"
                    onClick={onDelete}
                    disabled={deleting}
                    title="Remove building"
                >
                    <i className={deleting ? "ri-loader-4-line" : "ri-delete-bin-line"} />
                </Button>
            ) : null}
            <Button color="light" size="sm" onClick={onBack}>
                Back to Buildings
            </Button>
        </div>
    </div>
);
